.passwordInput {
  .suffix {
    position: absolute;
    right: var(--ixf-input-padding-horizontal);
    padding-right: 0;
  }

  .toggle {
    cursor: pointer;
    font-family: var(--ixf-font-family-main);
    font-size: 0.875rem;
    line-height: 1.5rem;
    font-weight: var(--ixf-font-weight-main-medium);
    color: var(--ixf-text-tone-md);

    &:disabled {
      cursor: default;
    }
  }

  input[type="password"] {
    padding-right: var(--ixf-space-10);
    font-family: inherit;
    -webkit-font-smoothing: antialiased;
  }
}
